var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableProperties from './table-properties';
import { TableEvent } from "../enums";
var SelectedRows = /** @class */ (function (_super) {
    __extends(SelectedRows, _super);
    function SelectedRows() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selected = [];
        return _this;
    }
    Object.defineProperty(SelectedRows.prototype, "selectedQueryName", {
        get: function () {
            return "".concat(this.prefix, "selected");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectedRows.prototype, "allSelected", {
        get: function () {
            if (this.objectPrimaryKeys.length == 0 || this.selected.length == 0) {
                return false;
            }
            // Check if all PKs exist in selected
            for (var i = 0; i < this.objectPrimaryKeys.length; i++) {
                if (this.selected.indexOf(this.objectPrimaryKeys[i]) == -1) {
                    return false;
                }
            }
            return true;
        },
        set: function (checked) {
            var selected = this.selected;
            for (var i = 0; i < this.objectPrimaryKeys.length; i++) {
                var index = selected.indexOf(this.objectPrimaryKeys[i]);
                if (index == -1 && checked) {
                    selected.push(this.objectPrimaryKeys[i]);
                }
                else if (index > -1 && !checked) {
                    selected.splice(index, 1);
                }
            }
            this.selected = selected;
        },
        enumerable: false,
        configurable: true
    });
    SelectedRows.prototype.onSelectedChanged = function () {
        window.dispatchEvent(new CustomEvent(TableEvent.SelectedChanged, {
            detail: {
                id: this.id,
                selected: this.selected
            }
        }));
    };
    __decorate([
        Watch('selected')
    ], SelectedRows.prototype, "onSelectedChanged", null);
    SelectedRows = __decorate([
        Component({
            mixins: [TableProperties]
        })
    ], SelectedRows);
    return SelectedRows;
}(Mixins(TableProperties)));
export default SelectedRows;
